import { Tooltip, TooltipContent } from '@components/ui/Tooltip/Tooltip';
import { InfoIcon } from '@utils/icons';
import styles from './InfoTip.module.css';

interface IInfoTipProps {
  /** The explanation — shown on hover and focus, and the icon's accessible
   *  name. */
  text: string;
  /** Muted lines under `text` — a list the explanation spells out in full
   *  (a restricted area's floors, professions and certificates). They join
   *  the icon's accessible name too. */
  lines?: string[];
  /** Placement tweaks from the host (margin, alignment) — the glyph's own
   *  look stays this component's. */
  className?: string;
}

/**
 * The small ⓘ beside a label or title that says what it means — the
 * Productivity page's treatment: a 12 px info glyph in the grey `hint`
 * tooltip. Focusable, so the text is reachable without a mouse. Sits beside
 * a `<label>`, never inside it: inside, the text would join the field's
 * accessible name.
 */
export function InfoTip({ text, lines, className }: IInfoTipProps) {
  return (
    <Tooltip content={lines ? <TooltipContent title={text} lines={lines} /> : text}>
      <span
        className={[styles.infoTip, className].filter(Boolean).join(' ')}
        tabIndex={0}
        aria-label={lines ? [text, ...lines].join('. ') : text}
      >
        <InfoIcon size={12} />
      </span>
    </Tooltip>
  );
}
